import{css as o}from"styled-components";import t from"../../assets/fonts/Roboto/Roboto-Light.ttf.js";import f from"../../assets/fonts/Roboto/Roboto-Regular.ttf.js";import r from"../../assets/fonts/Roboto/Roboto-Medium.ttf.js";import s from"../../assets/fonts/Roboto/Roboto-Bold.ttf.js";import{CommonFontStyle as e}from"./common.js";const m=o`
  @font-face {
    font-family: 'Roboto';
    src: url(${t}) format('truetype');
    font-weight: 100;
  }
  @font-face {
    font-family: 'Roboto';
    src: url(${f}) format('truetype');
    font-weight: 400;
  }
  @font-face {
    font-family: 'Roboto';
    src: url(${r}) format('truetype');
    font-weight: 500;
  }
  @font-face {
    font-family: 'Roboto';
    src: url(${s}) format('truetype');
    font-weight: 600;
  }
`,n=o`
  font-family: 'Roboto', sans-serif;
  ${e};
  ${m}
`;export{m as RobotoFont,n as RobotoFontStyle};
//# sourceMappingURL=robotoFont.js.map
